import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './i18n';
import '@livekit/components-styles';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { LanguageProvider } from './context/LanguageContext';
import { ChatSessionProvider } from './context/ChatSessionContext';
import { ToastProvider } from './context/ToastContext';
import { DrawerProvider } from './context/DrawerContext';
import { FeatureFlagsProvider } from './context/FeatureFlagsContext';
import { EntitlementsProvider } from './context/EntitlementsContext';
import { SocketProvider } from './context/SocketContext';
import { LocationProvider } from './context/LocationContext';
import { NotificationBadgeProvider } from './context/NotificationBadgeContext';
import { DealsBadgeProvider } from './context/DealsBadgeContext';
import { TripGenerationProvider } from './context/TripGenerationContext';
import { AppActionProvider } from './context/AppActionContext';
import { AttributionProvider } from './context/AttributionContext';
import Navigation from './components/Navigation';
import View from './common/View';
import ToastHost from './common/ToastHost';
import LowBalanceMonitor from './components/LowBalanceMonitor';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

function App(): React.JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ToastProvider>
          <ToastHost />
          <DrawerProvider>
            <View className="app-container">
              <ChatSessionProvider>
                <LanguageProvider>
                  <AuthProvider>
                    <UserProvider>
                      <FeatureFlagsProvider>
                        <EntitlementsProvider>
                          <SocketProvider>
                            <AttributionProvider>
                              <LocationProvider>
                                <NotificationBadgeProvider>
                                  <DealsBadgeProvider>
                                    <TripGenerationProvider>
                                      <AppActionProvider>
                                        <LowBalanceMonitor />
                                        <Navigation />
                                      </AppActionProvider>
                                    </TripGenerationProvider>
                                  </DealsBadgeProvider>
                                </NotificationBadgeProvider>
                              </LocationProvider>
                            </AttributionProvider>
                          </SocketProvider>
                        </EntitlementsProvider>
                      </FeatureFlagsProvider>
                    </UserProvider>
                  </AuthProvider>
                </LanguageProvider>
              </ChatSessionProvider>
            </View>
          </DrawerProvider>
        </ToastProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
